// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1In9P","checkboxCol":"Table_checkboxCol__xBwkS","emailCol":"Table_emailCol__1hGtl","actionCol":"Table_actionCol__p_wNX"};